import { postReq, deleteReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import {
  AdvanceSharePack,
  AdvanceSharePackItem,
  AdvanceSharePackItemPaginationFilterRequest,
  AdvanceSharePackPaginationFilterRequest,
  UpsertAdvanceSharePack,
  UpsertAdvanceSharePackItem,
} from '@/models/advance-share-pack.model';
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";

// Pack

export const getPagedAdvanceSharePacks = async (input: AdvanceSharePackPaginationFilterRequest): Promise<PagedResponseModel<AdvanceSharePack>> => {
  return await getReq(createUrl("a/AdvanceShare/Pack/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getAdvanceSharePack = async (id: number): Promise<BaseResponseModel<AdvanceSharePack>> => {
  return await getReq(createUrl(`a/AdvanceShare/Pack/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertAdvanceSharePack = async (input: UpsertAdvanceSharePack): Promise<BaseResponseModel<AdvanceSharePack>> => {
  return await postReq(createUrl("a/AdvanceShare/Pack/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const deleteAdvanceSharePack = async (id: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/AdvanceShare/Pack/Delete/${id}`),
  ).then((res: any) => res.data);
};

// Pack Items

export const getPagedAdvanceSharePackItems = async (input: AdvanceSharePackItemPaginationFilterRequest): Promise<PagedResponseModel<AdvanceSharePackItem>> => {
  return await getReq(createUrl("a/AdvanceShare/PackItem/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const upsertAdvanceSharePackItem = async (input: UpsertAdvanceSharePackItem): Promise<BaseResponseModel<AdvanceSharePackItem>> => {
  return await postReq(createUrl("a/AdvanceShare/PackItem/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const deleteAdvanceSharePackItem = async (id: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/AdvanceShare/PackItem/Delete/${id}`),
  ).then((res: any) => res.data);
};
